import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Block = ({ title, children }) => (
    <section className="mt-10">
        <h2 className="font-serif text-2xl font-semibold text-ink">{title}</h2>
        <div className="mt-4 space-y-4 text-base text-[#526063] leading-relaxed">{children}</div>
    </section>
);

const CONTENT = {
    privacy: {
        title: "Privacy Policy",
        testid: "privacy-page",
        updated: "Ultimo aggiornamento: settembre 2026",
        render: () => (
            <>
                <Block title="1. Titolare del trattamento">
                    <p>
                        Il titolare del trattamento dei dati personali è il <strong>Dott. Giovanni De Lorenzo</strong>, psicologo e psicoterapeuta, con studio in Via Alessandro Volta, 85025 Melfi (PZ) — Albo degli Psicologi, Sezione A, n. 9539.
                    </p>
                    <p>
                        Contatti del titolare: email <a href="mailto:studio@psicologogiovannidelorenzo.it" className="text-petrol underline underline-offset-2">studio@psicologogiovannidelorenzo.it</a> — tel. <a href="tel:+393341768041" className="text-petrol underline underline-offset-2">+39 334 176 8041</a>.
                    </p>
                </Block>
                <Block title="2. Dati raccolti e finalità del trattamento">
                    <p>
                        Tramite il modulo di contatto presente su questo sito vengono raccolti i seguenti dati: nome e cognome, indirizzo email, numero di telefono (facoltativo) e il contenuto del messaggio inviato.
                    </p>
                    <p>
                        Tali dati sono trattati esclusivamente per: rispondere alla richiesta dell'interessato, fornire informazioni sui servizi e gestire l'eventuale prenotazione di un colloquio.
                    </p>
                    <p>
                        <strong>Dati particolari (art. 9 GDPR):</strong> si invita a non inserire nel modulo informazioni dettagliate sul proprio stato di salute. Tali informazioni, se necessarie, saranno trattate nel rispetto della normativa sul segreto professionale nell'ambito della relazione clinica.
                    </p>
                </Block>
                <Block title="3. Base giuridica e modalità del trattamento">
                    <p>
                        Il trattamento si fonda sull'art. 6, par. 1, lett. b) del Regolamento (UE) 2016/679 (esecuzione di misure precontrattuali richieste dall'interessato). I dati sono trattati con strumenti informatici, con misure tecniche e organizzative adeguate a garantirne sicurezza e riservatezza.
                    </p>
                </Block>
                <Block title="4. Conservazione e comunicazione dei dati">
                    <p>
                        I dati sono conservati per il tempo necessario a gestire la richiesta e, in caso di avvio di un percorso, secondo i termini previsti dalla normativa sanitaria e deontologica. I dati non sono ceduti, venduti o comunicati a terzi, salvo obblighi di legge.
                    </p>
                </Block>
                <Block title="5. Statistiche di visita (Cloudflare Web Analytics)">
                    <p>
                        Questo sito utilizza Cloudflare Web Analytics, un servizio di statistiche che non usa cookie, non traccia i singoli visitatori e raccoglie solo dati aggregati e anonimi (pagine visitate, provenienza, tipo di dispositivo), al solo scopo di migliorare il sito.
                    </p>
                </Block>
                <Block title="6. Diritti dell'interessato">
                    <p>
                        Ai sensi degli artt. 15–22 del GDPR, l'interessato può esercitare in qualsiasi momento i diritti di accesso, rettifica, cancellazione, limitazione, opposizione e portabilità dei dati, scrivendo a <a href="mailto:studio@psicologogiovannidelorenzo.it" className="text-petrol underline underline-offset-2">studio@psicologogiovannidelorenzo.it</a>.
                    </p>
                    <p>
                        È inoltre possibile proporre reclamo al Garante per la protezione dei dati personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-petrol underline underline-offset-2">www.garanteprivacy.it</a>).
                    </p>
                </Block>
            </>
        ),
    },
    cookie: {
        title: "Cookie Policy",
        testid: "cookie-page",
        updated: "Ultimo aggiornamento: settembre 2026",
        render: () => (
            <>
                <Block title="1. Cosa sono i cookie">
                    <p>
                        I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente per garantire il corretto funzionamento delle pagine e, in alcuni casi, raccogliere informazioni statistiche.
                    </p>
                </Block>
                <Block title="2. Cookie utilizzati da questo sito">
                    <p>
                        <strong>Cookie tecnici (necessari):</strong> indispensabili per la navigazione e per il funzionamento del sito (ad esempio gestione della sessione e preferenze di visualizzazione). Non richiedono consenso.
                    </p>
                    <p>
                        <strong>Cookie di analisi:</strong> il sito può utilizzare strumenti di analisi aggregata e anonimizzata del traffico per migliorare contenuti ed esperienza di navigazione. Non vengono utilizzati cookie di profilazione pubblicitaria né cookie di terze parti a scopo di marketing.
                    </p>
                </Block>
                <Block title="3. Statistiche senza cookie">
                    <p>
                        Questo sito utilizza Cloudflare Web Analytics, un servizio di statistiche che non usa cookie, non traccia i singoli visitatori e raccoglie solo dati aggregati e anonimi (pagine visitate, provenienza, tipo di dispositivo), al solo scopo di migliorare il sito. Per questo motivo non è presente alcun banner di consenso: non vengono utilizzati cookie di profilazione.
                    </p>
                </Block>
                <Block title="4. Gestione delle preferenze">
                    <p>
                        È possibile disabilitare o cancellare i cookie in qualsiasi momento tramite le impostazioni del proprio browser. La disattivazione dei cookie tecnici può compromettere alcune funzionalità del sito.
                    </p>
                </Block>
                <Block title="5. Titolare e contatti">
                    <p>
                        Titolare del trattamento: Dott. Giovanni De Lorenzo — Via Alessandro Volta, 85025 Melfi (PZ) — <a href="mailto:studio@psicologogiovannidelorenzo.it" className="text-petrol underline underline-offset-2">studio@psicologogiovannidelorenzo.it</a>. Per maggiori informazioni sul trattamento dei dati personali si rimanda alla <Link to="/privacy-policy" className="text-petrol underline underline-offset-2">Privacy Policy</Link>.
                    </p>
                </Block>
            </>
        ),
    },
};

export default function Legal({ type }) {
    const c = CONTENT[type];
    useEffect(() => {
        document.title = `${c.title} | Psicologo Dott. Giovanni De Lorenzo`;
        window.scrollTo(0, 0);
    }, [c.title]);

    return (
        <div className="min-h-screen bg-cream" data-testid={c.testid}>
            <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
                <Link
                    to="/"
                    data-testid="legal-back-link"
                    className="inline-flex items-center gap-2 text-sm font-semibold text-petrol hover:text-petrol-soft transition-colors duration-300"
                >
                    <ArrowLeft size={16} /> Torna alla home
                </Link>
                <h1 className="mt-8 font-serif text-4xl sm:text-5xl text-ink">{c.title}</h1>
                <p className="mt-3 text-xs uppercase tracking-[0.2em] text-sage font-semibold">
                    Psicologo Dott. Giovanni De Lorenzo — {c.updated}
                </p>
                {c.render()}
            </div>
        </div>
    );
}
